import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';

import { setMetadataFieldType } from './../../../store/actions/metadata.actions';

const fieldTypes = ['', 'CHECKBOX', 'DATETIME', 'MONEY', 'NUMBER', 'TEXT'];

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: (48 * 4.5) + 8,
      width: 250,
    },
  },
};

const styles = () => ({
  formControl: {
    minWidth: 120,
  },
});

class FieldTypeContainer extends React.Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
  }

  handleChange(event) {
    this.props.setMetadataFieldType(this.props.column.key, event.target.value);
  }

  // eslint-disable-next-line class-methods-use-this
  renderSelectOptions() {
    return fieldTypes.map(option => (
      <MenuItem
        key={option}
        value={option}
      >
        {option}
      </MenuItem>
    ));
  }

  render() {
    const { classes, column } = this.props;

    return (
      <FormControl className={classes.formControl}>
        <Select
          onChange={e => this.handleChange(e)}
          MenuProps={MenuProps}
          value={column.fieldType}
          disabled={column.type === 'Skip'}
        >
          {this.renderSelectOptions()}
        </Select>
      </FormControl>
    );
  }
}

FieldTypeContainer.propTypes = {
  column: PropTypes.shape({
    key: PropTypes.string,
    type: PropTypes.string,
    fieldType: PropTypes.string,
  }).isRequired,
  setMetadataFieldType: PropTypes.func.isRequired,
  /* eslint-disable react/forbid-prop-types */
  classes: PropTypes.object.isRequired,
  /* eslint-enable */
};

export default withStyles(styles)(connect(null, { setMetadataFieldType })(FieldTypeContainer));
